let config = null;

export function loadConfig() {
  if (!config) {
    return fetch('/config.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(json => {
        config = json;
        return config;
      })
      .catch(error => {
        console.error('Failed to load config:', error);
        config = {}; // Manejo de errores
        return config;
      });
  }
  return Promise.resolve(config); // Devuelve una promesa ya resuelta si la configuración ya está cargada
}